import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

// Attention case should be respected
export default function workspaceIdsReducer(state = initialState.workspaceIds, action: any) {
  switch (action.type) {
    case types.SAVE_SUBSCRIPTION_IDS_SUCCESS:
      return action.workspaceIds;
    default:
      return state;
  }
}
